import { useHistory } from "react-router-dom";

import useQuery from "hooks/useQuery";

import { DEFAULT_STOP_LIST_TAB, STOP_LIST_TAB_KEYS } from "features/StopList/constants";
import { StopListTab } from "features/StopList/types";

const isStopListTab = (value: string | undefined): value is StopListTab =>
    STOP_LIST_TAB_KEYS.some((key) => key === value);

// Активный таб живёт в ?tab=; пишем через replace, чтобы «назад» браузера не листал табы.
export const useActiveTab = (): [StopListTab, (tab: StopListTab) => void] => {
    const history = useHistory();
    const { tab } = useQuery<{ tab?: string }>();

    const activeTab: StopListTab = isStopListTab(tab) ? tab : DEFAULT_STOP_LIST_TAB;

    const setActiveTab = (next: StopListTab) => {
        const params = new URLSearchParams(history.location.search);
        params.set("tab", next);
        history.replace({ search: params.toString() });
    };

    return [activeTab, setActiveTab];
};
